$(function () {
    var maxPhoneWidth = 767;

    var headers = $('a.search-filter-header').click(function (e) {
        var $btn = $(e.delegateTarget);
        var icon = $('i', $btn);
        if (icon.is(':visible')) {
            $('i', $btn).toggleClass('cc-arrow-down cc-arrow-up');
        } else {
            var $collapse;
            e.preventDefault();
            e.stopPropagation();
            if ($btn.data('target') && ($collapse = $($btn.data('target'))).length) {
                if ($collapse.is(':hidden')) {
                    $collapse.$collapse('show');
                }
            }
        }
    });
    var panels = headers.map(function (i, item) {
        var $item = $(item);
        var $collapse;
        if ($item.data('target') && ($collapse = $($item.data('target'))).length) {
            return $collapse;
        }
    });
    // Make sure the filters are always shown when switching between phone breakpoint
    if (window.matchMedia) {
        var xsMatch = window.matchMedia('(max-width: ' + maxPhoneWidth + 'px)');
        xsMatch.addListener(showPanels);
        if (xsMatch.matches) {
            showPanels(xsMatch);
        }
    } else {
        var $window = $(window);
        var isSmall;
        $(window).on('resize', function () {
            var newIsSmall = $window.width() <= maxPhoneWidth;
            if (newIsSmall !== isSmall) {
                isSmall = !isSmall;
                showPanels({ matches: isSmall });
            }
        });
        $(window).resize();
    }
    function showPanels(e) {
        if (e.matches) {
            panels.collapse('hide');
        } else {
            panels.collapse('show');
        }
    }
});